"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateOnHandlerMethods = void 0;
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const next_utils_metrics_1 = require("@gerenciatd/next.utils.metrics");
const next_app_controller_reducers_sagas_main_reducer_1 = require("@gerenciatd/next.app-controller.reducers-sagas.main-reducer");
/**
 * @name Link
 * @description atomic component
 * @param {any} props
 * @param {React.Ref} ref
 * @returns {React.FC}
 */
const filePath = '[Link]';
const ENTER_KEY = 'enter';
const RIGHT_MOUSE_BUTTON = 2;
const properKeyChecker = (e) => e && e.code && e.code.toLowerCase() === ENTER_KEY;
const properMouseButtonChecker = (e) => (e && e.which && e.which !== RIGHT_MOUSE_BUTTON) ||
    (e && e.button && e.button !== RIGHT_MOUSE_BUTTON);
const wrapperFunction = ({ action2Execute = null, throwSonda, taggingInfo, }) => {
    try {
        const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
        const isFrontApp = typeof window !== 'undefined';
        // si estoy en cliente (window) y estoy en dev obligo al parametro
        const isMetricsDevEnable = isFrontApp && window.location.search.indexOf('metrics') > -1;
        if ((isFrontApp && currentEnv !== 'dev') || isMetricsDevEnable) {
            (0, next_utils_metrics_1.sendCMSEvent)(taggingInfo);
        }
        if (action2Execute) {
            action2Execute();
        }
    }
    catch (error) {
        let info = '';
        try {
            info = `Element taggingInfo: ${JSON.stringify(taggingInfo)}`;
        }
        catch (e) {
            console.error('No se pudo generar más info en base al taggingInfo');
        }
        console.error({ action2Execute });
        throwSonda(error, info, 'wrapperFunction');
    }
};
const generateOnHandlerMethods = ({ onClick, throwSonda, taggingInfo, disabled, }) => {
    let newOnClick = null;
    let newOnKeyDown = null;
    let newOnMouseDown = null;
    if (onClick) {
        newOnClick = (e) => {
            taggingInfo = Object.assign(Object.assign({}, taggingInfo), { eventType: 'click' });
            // console.log('newOnClickWithAction', e);
            wrapperFunction({ throwSonda, taggingInfo, action2Execute: onClick });
        };
        newOnKeyDown = (e) => {
            if (properKeyChecker(e)) {
                taggingInfo = Object.assign(Object.assign({}, taggingInfo), { eventType: 'enter' });
                // console.log('newOnKeyDownWithAction', e); 
                wrapperFunction({ throwSonda, taggingInfo, action2Execute: onClick });
            }
        };
        newOnMouseDown = (e) => {
            // console.log(e);
            if (properMouseButtonChecker(e)) {
                taggingInfo = Object.assign(Object.assign({}, taggingInfo), { eventType: 'clickMouseWheel' });
                // console.log('newOnKeyDownWithAction', e);
                wrapperFunction({ throwSonda, taggingInfo, action2Execute: onClick });
            }
        };
    }
    else {
        newOnClick = (e) => {
            taggingInfo = Object.assign(Object.assign({}, taggingInfo), { eventType: 'click' });
            wrapperFunction({ throwSonda, taggingInfo });
        };
        newOnKeyDown = (e) => {
            if (properKeyChecker(e)) {
                taggingInfo = Object.assign(Object.assign({}, taggingInfo), { eventType: 'enter' });
                wrapperFunction({ throwSonda, taggingInfo });
            }
        };
        newOnMouseDown = (e) => {
            // console.log('newOnKeyDown', e);
            if (properMouseButtonChecker(e)) {
                taggingInfo = Object.assign(Object.assign({}, taggingInfo), { eventType: 'clickMouseWheel' });
                wrapperFunction({ throwSonda, taggingInfo });
            }
        };
    }
    if (disabled) {
        newOnClick = () => {
            return false;
        };
        newOnKeyDown = () => {
            return false;
        };
        newOnMouseDown = () => {
            return false;
        };
    }
    return {
        newOnClick,
        newOnKeyDown,
        newOnMouseDown,
    };
};
exports.generateOnHandlerMethods = generateOnHandlerMethods;
const extendsAccesibility = ({ cmpTitle, cmpAriaLabel, screenReadable, taggingInfo, }) => {
    let title = cmpTitle;
    let ariaLabel = cmpAriaLabel;
    const ariaHidden = !screenReadable;
    if (!title && taggingInfo && taggingInfo.componentContent) {
        title = taggingInfo.componentContent;
    }
    if (!ariaLabel && taggingInfo && taggingInfo.componentContent) {
        ariaLabel = taggingInfo.componentContent;
    }
    return {
        title,
        ariaLabel,
        ariaHidden,
    };
};
const Link = ({ id, className, taggingInfo, target, title: cmpTitle, ariaLabel: cmpAriaLabel, screenReadable, href, throwSonda, children, onClick, buttonTypeHtml, disabled, }) => {
    const currentClassName = className ? `link ${className}` : 'link';
    /* accesibilidad */
    const { title, ariaLabel, ariaHidden } = extendsAccesibility({
        cmpTitle,
        cmpAriaLabel,
        screenReadable,
        taggingInfo,
    });
    /* wrapeamos funciones ejecutadoras */
    const { newOnClick: onClickHandler, newOnKeyDown: onKeyDownHandler, newOnMouseDown: onMouseDownHandler, } = (0, exports.generateOnHandlerMethods)({
        onClick,
        throwSonda,
        taggingInfo,
        disabled,
    });
    const finalCssName = !children
        ? `${currentClassName} nextLinkOverBox`
        : currentClassName;
    if (!href && !onClick) {
        return null;
    }
    if (!href) {
        return (react_1.default.createElement("button", { id: id || null, type: buttonTypeHtml, className: finalCssName, tabIndex: 0, "aria-label": ariaLabel, "aria-hidden": ariaHidden, title: title, onClick: onClickHandler, onKeyDown: onKeyDownHandler, onMouseDown: onMouseDownHandler, disabled: disabled }, children));
    }
    return (react_1.default.createElement("a", { id: id || null, role: "button", className: finalCssName, tabIndex: 0, "aria-label": ariaLabel, "aria-hidden": ariaHidden, title: title, target: target, href: disabled ? false : href, onClick: onClickHandler, onKeyDown: onKeyDownHandler, onMouseDown: onMouseDownHandler }, children));
};
Link.propTypes = {
    id: prop_types_1.default.string,
    className: prop_types_1.default.string,
    taggingInfo: prop_types_1.default.object.isRequired,
    target: prop_types_1.default.string,
    throwSonda: prop_types_1.default.func.isRequired,
    onClick: prop_types_1.default.func,
    buttonTypeHtml: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
    // no les pongo requiere para qu no cante dos veces
    title: prop_types_1.default.string,
    ariaLabel: prop_types_1.default.string,
    screenReadable: prop_types_1.default.bool,
};
Link.defaultProps = {
    id: null,
    className: '',
    onClick: null,
    buttonTypeHtml: 'button',
    title: '',
    target: '_self',
    disabled: false,
    ariaLabel: '',
    screenReadable: true,
};
const mapDispatchToProps = (dispatch) => ({
    throwSonda: (error, info, processName) => {
        return dispatch(next_app_controller_reducers_sagas_main_reducer_1.actions.throwSonda({
            filePath,
            processName,
            error,
            info,
            kind: next_app_controller_reducers_sagas_main_reducer_1.SONDA_KIND.ERROR,
        }));
    },
});
exports.default = (0, react_redux_1.connect)(null, mapDispatchToProps)(Link);
//# sourceMappingURL=index.js.map